import { GripHorizontal, GripVertical } from 'lucide-react';
import React from 'react';
import { sh2 } from '../../../styles/typography';

const INPUT_BASE_CLASS = 'w-full rounded-[10px] bg-white/80 border border-gray-200 px-3 py-2 text-base text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-400/50 focus:border-green-400';

const CustomSeater = ({
  customSeaterName,
  setCustomSeaterName,
  customSeaterRows,
  setCustomSeaterRows,
  customSeaterColumns,
  setCustomSeaterColumns,
  onAddTable
}) => {
  const handleAddTable = () => {
    if (!customSeaterName.trim()) {
      alert('Please enter a seater name');
      return;
    }
    if (onAddTable) {
      onAddTable({
        name: customSeaterName,
        rows: customSeaterRows,
        columns: customSeaterColumns
      });
    }
  };

  return (
    <div className="bg-white p-4">
      <h3 className={`${sh2} text-gray-800 font-semibold mb-3`}>Make custom seater</h3>
      <div className="space-y-3">
        <input
          type="text"
          value={customSeaterName}
          onChange={(e) => setCustomSeaterName(e.target.value)}
          placeholder="Seater number"
          className={INPUT_BASE_CLASS}
        />
        <div>
          <p className={`${sh2} text-gray-700 mb-2 text-sm`}>Select row and columns the table takes</p>
          <div className="flex items-center gap-2">
            <div className="relative flex-1">
              <div className="relative">
                <GripHorizontal className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" strokeWidth={2} />
                <input
                  type="number"
                  min="1"
                  max="10"
                  value={customSeaterRows}
                  onChange={(e) => {
                    const value = parseInt(e.target.value) || 1;
                    if (value >= 1 && value <= 10) {
                      setCustomSeaterRows(value);
                    }
                  }}
                  placeholder="Select row"
                  className={`${INPUT_BASE_CLASS} pl-10 pr-3 h-11`}
                />
              </div>
            </div>
            <span className="text-gray-400 text-lg">~</span>
            <div className="relative flex-1">
              <div className="relative">
                <GripVertical className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" strokeWidth={2} />
                <input
                  type="number"
                  min="1"
                  max="10"
                  value={customSeaterColumns}
                  onChange={(e) => {
                    const value = parseInt(e.target.value) || 1;
                    if (value >= 1 && value <= 10) {
                      setCustomSeaterColumns(value);
                    }
                  }}
                  placeholder="Select colum"
                  className={`${INPUT_BASE_CLASS} pl-10 pr-3 h-11`}
                />
              </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={handleAddTable}
          className="w-full py-3 px-4 rounded-[10px] bg-green-600 hover:bg-green-700 text-white font-semibold text-base transition-colors shadow-md"
        >
          Add table
        </button>
      </div>
    </div>
  );
};

export default CustomSeater;
